/* eslint-disable no-shadow */
import React, { Component } from "react";
import ErrorBoundary from "../../shared/error/ErrorBoundary";
import {
  loadJobPerformance,
  selectTab,
  resetDefaultFilters,
} from "../../../actions/employerAnalyticsActions";
// import FullScreenLoading from "../../shared/loaders/FullScreenLoading";
import { Wrapper } from "../styles/employer-analytics-styles";
import CandidateSubmission from "./CandidateSubmission";
import InterviewRate from "./InterviewRate";
import PlacementRate from "./PlacementRate";
import PlacementsMade from "./PlacementsMade";
import CostSpentOnPlacements from "./CostSpentOnPlacements";
import JobSuccessFee from "./JobSuccessFee";
import FillRate from "./FillRate";
import TimeToHire from "./TimeToHire";
import StageProgression from "./StageProgression";
import RecruitmentProcess from "./RecruitmentProcess";
import TimeToSubmission from "./TimeToSubmission";
import FullScreenLoading from "../../shared/loaders/FullScreenLoading";
import PropTypes from "prop-types";
import { connect } from "react-redux";
export interface IJobPerformanceProps {
  loading: boolean;
  selectTab: (tabType: string) => void;
  loadJobPerformance: ({ defaultFilters }) => void;
  resetDefaultFilters: ({ isFirstRun }) => void;
  currencySymbol: string;
  hasError: boolean;
}

export class JobPerformance extends Component<IJobPerformanceProps> {
  static propTypes = {
    loadJobPerformance: PropTypes.func.isRequired,
    selectTab: PropTypes.func.isRequired,
    currencySymbol: PropTypes.string.isRequired,
  };
  componentDidMount(): void {
    const defaultFilters = { timeframe: ["Last 12 Months"] };
    const { loadJobPerformance, selectTab } = this.props;
    selectTab("job_performance");
    this.props.resetDefaultFilters({ isFirstRun: true });
    loadJobPerformance({ defaultFilters: defaultFilters });
  }
  render(): React.ReactNode {
    const { loading, currencySymbol, hasError } = this.props;
    if (hasError) {
      return (
        <ErrorBoundary {...this.props}>
          <div></div>
        </ErrorBoundary>
      );
    }

    return (
      // <ErrorBoundary>
      <Wrapper>
        {loading ? (
          <FullScreenLoading />
        ) : (
          <>
            <PlacementsMade />
            <CostSpentOnPlacements currencySymbol={currencySymbol} />
            <RecruitmentProcess />
            <TimeToHire />
            <TimeToSubmission />
            <CandidateSubmission />
            <PlacementRate />
            <InterviewRate />
            <FillRate />
            <StageProgression />
            <JobSuccessFee />
          </>
        )}
      </Wrapper>
      // </ErrorBoundary>
    );
  }
}
interface IReduxState {
  employerAnalytics: {
    jobPerformanceLoading: boolean;
    JobPerformancehasError: boolean;
  };
}
const mapStateToProps = (state: IReduxState) => ({
  loading: state.employerAnalytics.jobPerformanceLoading,
  hasError: state.employerAnalytics.JobPerformancehasError,
});
export default connect(mapStateToProps, {
  loadJobPerformance,
  selectTab,
  resetDefaultFilters,
})(JobPerformance);
